// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rounded {\n    border-radius: 15px !important;\n    overflow: hidden;\n    float: left;\n    position: relative;\n    height: 100%;\n    width:inherit\n}\niframe {\n    float: left;\n}", ""]);
// Exports
module.exports = exports;
